








































































import { Component, Prop, Vue } from 'vue-property-decorator';
import PizzaLoader from './PizzaLoader.vue';
import PizzaIcon from './PizzaIcon.vue';
import Order from '../../logic/model/Order';
import Article from '../../logic/model/Article';
import OrderItem from '../../logic/model/OrderItem';
import _ from 'lodash'

@Component({
    components: {PizzaLoader,PizzaIcon},
    name: "shopping-cart",
})
export default class ShoppingCart extends Vue{
        
    private isExpanded:boolean = true;
    private search:string = "";
    private dialog:boolean = false;


    mounted() {

    }

    public get order():Order {
        return this.$store.state.order;
    }
    
    public get orderSize() {
        return this.order.length
    }

    public get orderItems() {
        let orderItems:Array<OrderItem> = this.$store.state.order.$orderItems;
        console.log(orderItems);
        return _.orderBy(orderItems,['$createdAt'],['asc'])
    }

    public get canSubmit() {
        return this.order.$orderConfirmed === false;
    }

    public printSum() {
        return this.order.getPrice();
    }

    public get isCartSubmitted() {
        return this.order.$orderConfirmed
    }

    public   calculateOrderPrice(orderItem:OrderItem) {

        return this.order.calcOrderItemPrice(orderItem);

    }

    private getArticleicon(article:Article) {
        if (article.$description) {
            let loweredIngredients = article.$description.toLowerCase();
            if (loweredIngredients.includes('salami')) {
                return 'salami-svgrepo-com'
            } else if (loweredIngredients.includes('ananas')) {
                return 'pineapple'
            } else if (loweredIngredients.includes('schinken')) {
                return 'ham'
            } else if (loweredIngredients.includes('thunfisch')) {
                return 'tuna'
                
            } else if (loweredIngredients.includes('hähnchenfleisch')) {
                return 'spaguetti'
            } else if (loweredIngredients.includes('käse')) {
                return 'cheese'
            } else {
                return 'pizza'
            }
        } else {
            return 'pizza'
        }
        
    }
    
    public submitCart() {
        // axios.post('api/cart/submit');
    }    
    
    public login() {
        this.dialog = true;
    }

       
}
